/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { URL } from "../../../constants/URL";
import CS from "../../../services/commonService";
import Icon from "../../icons/index";
import BreadCrumbs from "../../common/breadcrumbs";
import {
	useGetUserDetails,
	useDeleteUser,
	useGetAllGiftStatus,
	useGetAllPaymentStatus,
	useGetOrderByUser,
	useSaveUserInfo,
} from "../../../queryHooks";
import qs from "qs";

import { useStore } from "../../../zustand/store";
import Modal from "../../common/Modal";
import OrdersTable from "./ordersTable";
import GiftsTable from "./giftsTable";
import HelpQueriesTable from "./helpQueriesTable";
import ReferredUsers from "./referredUsersTable";
import { useFormik } from "formik";
import { referralCodeSchema } from "../../../validations";
import moment from "moment";
import InputModal from "../../common/InputModal";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";
import PromoGiftsTable from "./PromoGiftsTable";
//	Component starts
const UserDetails = () => {
	const setLoading = useStore((state) => state.setLoading);
	const lastPageData = useStore((state) => state.lastPageData);
	//	Params
	const { slug } = useParams();
	//	Navigation
	const navigate = useNavigate();
	//	State values
	const [key, setKey] = useState(lastPageData?.[`tabKey${slug}`] || "orders");
	const [openViewImageModal, setOpenViewImageModal] = useState(false);
	const [referalEdit, setReferalEdit] = useState(true); //used as a flag
	const [referalCodeData, setReferalCodeData] = useState({
		referralCode: "",
	});
	const [giftStatusList, setGiftStatusList] = useState();
	const [paymentStatusList, setPaymentStatusList] = useState();
	const [tabChangeCounter, setTabChangeCounter] = useState(0);
	const [userId, setUserId] = useState(slug);
	const [openModal, setOpenModal] = useState(false);

	useEffect(() => {
		if (slug) window.scrollTo(0, 0);
		setUserId(slug);
		if (lastPageData?.[`tabKey${slug}`]) {
			setKey(lastPageData?.[`tabKey${slug}`]);
		} else {
			setKey("orders");
		}
	}, [slug]);

	/******************************************************************************************
	@Purpose    :   To get the user details
	*******************************************************************************************/

	const { data: dataUserDetails } = useGetUserDetails(userId);

	const { data: dataGetOrderByUser } = useGetOrderByUser(userId);

	/******************************************************************************************
	@Purpose    :   To delete the user details
	*******************************************************************************************/
	const {
		mutateAsync: deleteUser,
		error: errorDeleteUser,
		data: dataDeleteUser,
	} = useDeleteUser();

	useEffect(() => {
		if (dataDeleteUser) {
			setLoading(false);
			if (dataDeleteUser?.status === "success") {
				setOpenModal(false);
				CS.showSuccessMessage(dataDeleteUser?.message);
			} else if (dataDeleteUser?.status === "fail") {
				CS.showErrorMessage(dataDeleteUser?.message);
			}
		}
	}, [dataDeleteUser]);

	const handleUserDelete = () => {
		deleteUser(userId);
	};

	const {
		mutateAsync: saveReferCode,
		error: errorRefferalCode,
		data: dataSaveReferralCode,
	} = useSaveUserInfo();

	useEffect(() => {
		if (dataUserDetails) {
			if (dataUserDetails?.status === "success") {
				setReferalCodeData({
					referralCode: dataUserDetails?.data?.referral_code,
				});
			} else if (dataUserDetails.status === "fail") {
				CS.showErrorMessage(dataUserDetails?.message);
			}
		}
	}, [dataUserDetails]);

	useEffect(() => {
		if (dataSaveReferralCode) {
			setLoading(false);
			if (dataSaveReferralCode?.status === "success") {
				setReferalEdit(true);
				CS.showSuccessMessage(dataSaveReferralCode?.message);
			} else if (dataSaveReferralCode?.status === "fail") {
				CS.showErrorMessage(dataSaveReferralCode?.message);
			}
		}
	}, [dataSaveReferralCode]);

	useEffect(() => {
		if (errorRefferalCode) {
			setLoading(false);
			CS.showErrorMessage(errorRefferalCode?.response?.data?.message);
		}
	}, [errorRefferalCode]);

	useEffect(() => {
		if (errorDeleteUser) {
			setLoading(false);
			CS.showErrorMessage(errorDeleteUser?.response?.data?.message);
		}
	}, [errorDeleteUser]);

	const { values, errors, touched, handleChange, handleSubmit } = useFormik({
		initialValues: referalCodeData,
		enableReinitialize: true,
		validationSchema: referralCodeSchema,
		onSubmit: () => {
			let payload = {
				body: {
					referral_code: values.referralCode.trim(),
				},
				userId: userId,
			};

			saveReferCode(payload);
			setLoading(true);
		},
	});

	const { data: dataGetAllGiftStatus } = useGetAllGiftStatus();

	useEffect(() => {
		if (dataGetAllGiftStatus && dataGetAllGiftStatus.data) {
			let _users = [];
			dataGetAllGiftStatus.data.forEach((element) => {
				_users.push({
					label: element.value,
					value: element.id,
				});
			});
			setGiftStatusList(_users);
		}
	}, [dataGetAllGiftStatus]);

	const { data: dataGetAllPaymentStatus } = useGetAllPaymentStatus();

	useEffect(() => {
		if (dataGetAllPaymentStatus && dataGetAllPaymentStatus.data) {
			let _users = [];
			dataGetAllPaymentStatus.data.forEach((element) => {
				_users.push({
					label: element.value,
					value: element.id,
				});
			});
			setPaymentStatusList(_users);
		}
	}, [dataGetAllPaymentStatus]);

	const handleTabChange = (k) => {
		setKey(k);
		setTabChangeCounter((count) => count + 1);
	};

	const closeModalHandler = () => {
		setOpenModal(false);
	};

	const modalDescriptions = [
		"- This action is irreversible i.e, once you delete user you will not be able to recover this user.",
		"- This will remove all the data of this user from our platform.",
		"- Gifts sended by this user would still be available for redemption.",
	];

	const UserDetails = ({ user }) => {
		return (
			<div className="row mb-2">
				<div className="col-md-6">
					<p>
						Name:{" "}
						<strong>
							{user?.first_name} {user?.last_name}
						</strong>
					</p>
				</div>
				<div className="col-md-6">
					<p>
						Username: <strong>{user?.username}</strong>
					</p>
				</div>
			</div>
		);
	};

	return (
		<>
			<div className="d-flex align-items-center justify-content-between flex-wrap mb-2">
				<BreadCrumbs
					title="Users Management"
					data={[
						{ label: "Users", path: URL.onboarderedUsers },
						{ label: "User Details" },
					]}
				/>
				{dataUserDetails?.data?.is_deleted !== 1 && (
					<div className="text-right">
						<Link
							to={URL.updateUserSlug.replace(":slug", slug)}
							className="btn btn-primary ml-3"
						>
							<em className="bx bx-edit mr-2"></em> Edit
						</Link>
						<button
							className="btn btn-danger ml-3"
							type="button"
							onClick={() => setOpenModal(true)}
						>
							<span className="bx bx-trash-alt mr-2"></span> Delete
						</button>
					</div>
				)}
			</div>
			<div className="card-deck user-details-deck">
				<div className="card persona-info-card profile-card mb-5">
					<h4 className="d-flex align-items-center title mb-4">
						<i className="bx bx-user mr-1" />
						Personal Information
					</h4>
					<div className="d-flex info-content">
						<div className="personal-info">
							<ul className="info-list">
								<li>
									<h6 className="info-title">FULL NAME</h6>
									<span className="sub-content">
										{dataUserDetails?.data?.first_name || "-"}{" "}
										{dataUserDetails?.data?.last_name || "-"}
									</span>
								</li>
								<li>
									<h6 className="info-title">USERNAME</h6>
									<span className="sub-content">
										{dataUserDetails?.data?.username || "-"}
									</span>
								</li>
								<li>
									<h6 className="info-title">EMAIL ADDRESS</h6>
									<span className="sub-content">
										{dataUserDetails?.data?.email || "-"}
										{dataUserDetails?.data?.email &&
											(dataUserDetails?.data?.is_email_verified === 1 ? (
												<img
													title="Verified"
													className="verified-logo"
													src="/assets/images/check.png"
												/>
											) : (
												<img
													title="Unverified"
													className="verified-logo"
													src="/assets/images/exclamation-mark-icon.png"
												/>
											))}
									</span>
								</li>
								<li>
									<h6 className="info-title">PHONE NUMBER</h6>
									<span className="sub-content">
										{dataUserDetails?.data?.mobile || "-"}
										{dataUserDetails?.data?.mobile &&
											(dataUserDetails?.data?.is_mobile_verified === 1 ? (
												<img
													title="Verified"
													className="verified-logo"
													src="/assets/images/check.png"
												/>
											) : (
												<img
													title="Unverified"
													className="verified-logo"
													src="/assets/images/exclamation-mark-icon.png"
												/>
											))}
									</span>
								</li>
								<li>
									<h6 className="info-title">DATE OF BIRTH</h6>
									<span className="sub-content">
										{dataUserDetails?.data?.date_of_birth
											? moment
													.utc(dataUserDetails?.data?.date_of_birth)
													.format("MM/DD/YYYY")
											: "-"}
									</span>
								</li>
								<li>
									<h6 className="info-title">REFERRAL CODE</h6>
									<div
										className="sub-content"
										style={{ display: "inline-flex" }}
									>
										<span>
											{referalEdit ? (
												values?.referralCode
											) : (
												<>
													<input
														type="text"
														style={{ borderColor: "0.5px solid #0000" }}
														name="referralCode"
														value={values.referralCode}
														onChange={(e) => {
															let event = {
																target: {
																	name: "referralCode",
																	value: e.target.value.toUpperCase(),
																},
															};
															handleChange(event);
														}}
														disabled={referalEdit}
													/>
												</>
											)}
											<span
												className="sub-content mt-1 w-100"
												style={{ color: "red", fontWeight: "lighter" }}
											>
												{errors.referralCode && touched.referralCode
													? errors.referralCode
													: null}
											</span>
										</span>
										{dataUserDetails?.data?.is_deleted !== 1 ? (
											referalEdit ? (
												<>
													<span
														className="bx bx-edit-alt mr-2"
														data-tip
														data-for="edit"
														onClick={() => {
															setReferalEdit(!referalEdit);
														}}
														style={{
															fontSize: "24px",
															paddingLeft: "5px",
															cursor: "pointer",
														}}
													></span>
													<ReactTooltip id="edit" place="top" effect="solid">
														{referalEdit ? "Edit" : "Save"}
													</ReactTooltip>
												</>
											) : (
												<>
													<span
														className="bx bx-save mr-1"
														data-tip
														data-for="save"
														onClick={handleSubmit}
														style={{
															fontSize: "24px",
															paddingLeft: "5px",
															cursor: "pointer",
														}}
													></span>
													<ReactTooltip id="save" place="top" effect="solid">
														{referalEdit ? "Edit" : "Save"}
													</ReactTooltip>
													<span
														className="bx bx-x"
														data-tip
														data-for="close"
														onClick={() => {
															let event = {
																target: {
																	name: "referralCode",
																	value:
																		dataUserDetails?.data?.referral_code?.toUpperCase(),
																},
															};
															handleChange(event);
															setReferalEdit(!referalEdit);
														}}
														style={{
															fontSize: "24px",
															paddingLeft: "5px",
															cursor: "pointer",
														}}
													></span>
													<ReactTooltip id="close" place="top" effect="solid">
														Close
													</ReactTooltip>
												</>
											)
										) : (
											<></>
										)}
									</div>
								</li>
								<li>
									<h6 className="info-title">TOTAL USERS REFERRED</h6>
									<span className="sub-content">
										{dataUserDetails?.data?.total_referred_users || "-"}
									</span>
								</li>
							</ul>
						</div>
						<div className="user-item">
							{dataUserDetails?.data?.profile_image_url ? (
								<div
									title="View image"
									className="user-image cursor-pointer"
									onClick={() => setOpenViewImageModal(true)}
								>
									{CS.renderImageUrl(dataUserDetails?.data?.profile_image_url)}
								</div>
							) : (
								<div className="user-image">{CS.renderImageUrl("")}</div>
							)}
						</div>
					</div>
				</div>
				<div className="card persona-info-card profile-card mb-5">
					<h4 className="d-flex align-items-center title mb-4">
						<i className="bx bx-package mr-1" />
						Order Info
					</h4>
					<div className="d-flex info-content">
						<div className="personal-info">
							<ul className="info-list">
								<li>
									<h6 className="info-title">TOTAL PLACED ORDERS</h6>
									<span className="sub-content">
										{dataGetOrderByUser?.data?.totalOrders}
									</span>
								</li>
								<li>
									<h6 className="info-title">TOTAL COMPLETED ORDERS</h6>
									<span className="sub-content">
										{dataGetOrderByUser?.data?.totalCompletedOrders}
									</span>
								</li>
								<li>
									<h6 className="info-title">TOTAL ORDERS AMOUNT</h6>
									<span className="sub-content">
										$ {dataGetOrderByUser?.data?.totalGrossAmount}
									</span>
								</li>
								<li>
									<h6 className="info-title">TOTAL TIPS</h6>
									<span className="sub-content">
										$ {dataGetOrderByUser?.data?.totalTips}
									</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div className="card notification-card tabs-block p-0">
				<Tabs
					className="pl-5 pt-3 tab-block"
					id="controlled-tab-example"
					activeKey={key}
					onSelect={handleTabChange}
				>
					<Tab eventKey="orders" title="Sent Gifts">
						<OrdersTable
							userId={userId}
							giftStatusList={giftStatusList}
							paymentStatusList={paymentStatusList}
							tabChangeCounter={tabChangeCounter}
							tabKey={"orders"}
						/>
					</Tab>
					<Tab eventKey="giftOrders" title="Received Gifts">
						<GiftsTable
							userId={userId}
							giftStatusList={giftStatusList}
							paymentStatusList={paymentStatusList}
							tabChangeCounter={tabChangeCounter}
							tabKey={"giftOrders"}
						/>
					</Tab>
					<Tab eventKey="promoGifts" title="Promo Gifts">
						<PromoGiftsTable
							userId={userId}
							tabChangeCounter={tabChangeCounter}
							tabKey={"promoGifts"}
						/>
					</Tab>
					<Tab eventKey="referredUser" title="Referred Users">
						<ReferredUsers
							userId={userId}
							tabChangeCounter={tabChangeCounter}
							tabKey={"referredUser"}
						/>
					</Tab>
					<Tab eventKey="helpQueries" title="Help Queries">
						<HelpQueriesTable
							userId={userId}
							tabChangeCounter={tabChangeCounter}
						/>
					</Tab>
				</Tabs>
			</div>
			<Modal
				open={openViewImageModal}
				onCloseModal={() => setOpenViewImageModal(false)}
			>
				<div className="modal-content">
					<img src={dataUserDetails?.data?.profile_image_url} />
				</div>
			</Modal>
			<Modal open={openModal} onCloseModal={closeModalHandler}>
				<InputModal
					title={
						"Are you sure you want to permanently delete this user account ?"
					}
					detailsComponent={<UserDetails user={dataUserDetails?.data} />}
					descriptions={modalDescriptions}
					onCloseModal={closeModalHandler}
					successHandler={handleUserDelete}
				/>
			</Modal>
		</>
	);
};

export default UserDetails;
